export default __webpack_public_path__ + "static/media/fuse.6d879ac8.png";